import { render, staticRenderFns } from "./SmallContactInfo.vue?vue&type=template&id=382aa426&"
import script from "./SmallContactInfo.vue?vue&type=script&lang=js&"
export * from "./SmallContactInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports